export default "/fonts/vendor/@fontsource/space-mono/files/space-mono-vietnamese-400-normal.woff2?9e70c424421f5b9baa0296a1bfe56273";